import React, { Component } from "react";
import { useLocation, withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import ClaimsBloc from "../../../bloc/claims_bloc";
import GeneralBloc from "../../../bloc/general_bloc";
import RouteBloc from "../../../bloc/route_bloc";
import App_claim_status_mini from "../../component/app_claim_status/app_claim_status_mini";
import AppEmptyData from "../../component/app_empty_data/app_empty_data";
import App_dropdown_filter2 from "../../component/app_filters/app_dropdown_filter2";
import App_search_filter from "../../component/app_filters/app_search_filter";
import App_header from "../../component/app_header/app_header";
import App_header_title_filter from "../../component/app_header_title/app_header_title_filter";
import App_sidebar from "../../component/app_sidebar_mrtt/app_sidebar";
import App_table from "../../component/app_table/app_table";
import Config from "../../../Config";
import UserAccessBloc from "../../../bloc/user_access_bloc";
import AppDialogFilter from "../../component/app_filters/app_dialog_filter";
import App_searching_dialog from "../../dialog/app_searching_dialog/app_searching_dialog";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import App_dropdown_filter from "../../component/app_filters/app_dropdown_filter";
import App_daterange_filter from "../../component/app_filters/app_daterange_filter";
import "./faq_screen.css";
import ProposalBloc from "../../../bloc/proposal_bloc";
import { setFilterBy } from "../../../data/redux/reducers/filterReducer";
import BaseScreen from "../base/base_screen/base_screen";
import UtilBloc from "../../../bloc/util_bloc";
import App_header_title_simple from "../../component/app_header_title/app_header_title_simple";
import { ReactComponent as ChevronRightIcon } from "../../../ChevronRight2.svg";
import { ReactComponent as InfoIcon } from "../../../Info.svg";
import FaqBloc from "../../../bloc/faq_bloc";
import AppModal from "../../component/app_modal/app_modal";

class FaqScreen extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            loading: false,
            route: routeParams,
            client: Config.context,
            keyword: '',
            userData: {
                // username: 'SHA002',
            },
            faqData: null,
        };
    }


    componentDidMount() {
        this.getUserData();
        this.getFaqData();
    }

    async getUserData() {
        let userData = await UserAccessBloc.getUserData();
        if (userData) {
            this.setState({
                userData: userData,
            });
        }
    }

    async getFaqData() {
        this.setState({ loading: true });
        let result = await FaqBloc.getFaqCategories(this.state.keyword);
        if (result.success) {
            this.setState({
                faqData: result.data,
                loading: false
            });
        } else {
            this.setState({
                loading: false,
                isOpen: true,
                title: 'Error',
                message: result.message
            })
        }

        console.log(result)
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }


    render() {
        return (
            <>
                <div>
                    {this.state.loading && this.loadingContent()}
                    {/* <BaseScreen
                        listener={(userSettings) => {
                            // console.log("claim", GeneralBloc.getModuleDetailsFromUserSetting(userSettings, "claim"))
                        }}
                    >*/}
                    <App_header
                        data={this.state.userData}
                        route={this.state.route.entity}
                    />
                    <App_sidebar route={this.state.route.entity}>
                        <div className="row">
                            <div className="col-6">
                                <App_header_title_simple
                                    title="FAQ - Takaful Mortgage Portal"
                                    description="Have questions? We are here to help"
                                />
                                <div className="faqscreen_link_container">
                                    {
                                        this.state.faqData && this.state.faqData.map((item, idx) => {
                                            return (
                                                <Link
                                                    to={`/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.faq}/${item.faq_category.id}`}
                                                    style={{ color: "black" }}
                                                >
                                                    <span className="faqscreen_section_title">{item.faq_category.nameEN}</span>
                                                    <ChevronRightIcon className="ml-2" />
                                                </Link>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="faqscreen_help_border">
                                    <div className="faqscreen_help_container p-3 d-flex">
                                        <div className="">
                                            <InfoIcon />
                                        </div>
                                        <div className="ml-3">
                                            <div className="faqscreen_help_header">Still Need help</div>
                                            <div className="faqscreen_help_text mt-1">For queries and assistance, please contact
                                                <span style={{ color: '#EE7623' }}> FWD Support Team Helpdesk</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-3">
                                        <div className="w-100 d-flex justify-content-between row m-0">
                                            <div className="faqscreen_help_text col-6 p-0">Email</div>
                                            <div className="faqscreen_help_value col-6 p-0 justify-content-end d-flex" style={{ wordWrap: 'break-word' }}>
                                                FWD.Support.Team@fwd.com.my
                                            </div>
                                        </div>
                                        <div className="w-100 d-flex justify-content-between mt-2 row m-0">
                                            <div className="faqscreen_help_text col-6 p-0">Operation Hours</div>
                                            <div className="faqscreen_help_value col-6 p-0 justify-content-end d-flex">
                                                Monday to Friday<br />
                                                9:00 a.m. to 5 p.m.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <AppModal
                            open={this.state.isOpen}
                            handleModalClose={() => this.setState({ isOpen: false })}
                            width={'50%'}
                            title={this.state.title}
                            subtitle={this.state.message}
                            positiveButtonText={'Close'}
                            handlePositivePress={() => this.setState({ isOpen: false })}
                            closable={false}
                        />

                    </App_sidebar>
                    {/* </BaseScreen> */}
                </div>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
});

const mapDispatchToProps = { setFilterBy };

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(FaqScreen)
);

